import { takeEvery, put, call } from "redux-saga/effects";
import {
  CREATE_UNIT,
  FETCH_UNITS,
} from "./actionTypes";
import {
  fetchUnitsSuccess,
  fetchUnitsFailure,
  createUnitSuccess,
  createUnitFailure,
  fetchUnits,
} from "./actions";
import { get, post, update, del } from "../../../helpers/api_helper";
import Swal from "sweetalert2";
// Fetch Units
function* fetchUnitsSaga() {
  try {
    const response = yield call(post, process.env.REACT_APP_GET_UNITS);
    yield put(fetchUnitsSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchUnitsFailure(error.message));
  }
}

function* createUnitSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const apiUrl = process.env.REACT_APP_SAVE_UNITS;
    const response = yield call(post, apiUrl, formData);
    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Unit saved successfully!",
      });
      yield put(createUnitSuccess(response));
      yield put(fetchUnits());

    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createUnitFailure(response));
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the role",
    });
    yield put(createUnitFailure(error.message));
  }
}

// Watcher Saga
function* roleSaga() {
  yield takeEvery(FETCH_UNITS, fetchUnitsSaga);
  yield takeEvery(CREATE_UNIT, createUnitSaga);
}

export default roleSaga;
